<!-- Muestra la linea y el punto de volcado establecido. -->
<template>
  <div class="div-componenteInformacionLineaYPunto">
    <f7-row class="row-componenteInformacionLineaYPunto">
      <f7-col>
        <span class="span-textoInformacionLineaYPunto">
          {{ `${$t('common.location')}:` }}
        </span> <span
          v-if="lineaDeProduccion != null"
          class="span-textoInformacionLineaYPunto"
        >
          {{ lineaDeProduccion.DescripcionCorta }}
        </span>
        <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
        <span class="span-textoInformacionLineaYPunto">
          /
        </span>
        <span
          v-if="(modo === 'volcado' || modo == null) && puntoDeVolcado != null"
          class="span-textoInformacionLineaYPunto"
        >
          {{ puntoDeVolcado.DescripcionCorta }}
        </span>
        <span
          v-if="modo === 'paletizado' && puntoDePaletizado != null"
          class="span-textoInformacionLineaYPunto"
        >
          {{ puntoDePaletizado.DescripcionCorta }}
        </span>
      </f7-col>
    </f7-row>
    <f7-row
      v-if="showLineaPedidoVenta && lineasPedido"
      class="row-lineaPedidoVenta"
    >
      <f7-col>
        <span class="span-textoInformacionLineaYPunto">
          {{ $t('production.productionLineInfo.salesOrderLine') }}
        </span> <span class="span-textoInformacionLineaYPunto">
          {{ lineasPedidoString }}
        </span>
      </f7-col>
    </f7-row>

    <f7-row
      v-if="showSalidaProduccion && salidaProduccion"
      class="row-salidasProduccion"
    >
      <f7-col>
        <span class="span-textoInformacionLineaYPunto">
          {{ $t('production.productionLineInfo.productionOutputs') }}
        </span> <span class="span-textoInformacionLineaYPunto">
          {{ salidasProduccionString }}
        </span>
      </f7-col>
    </f7-row>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';

export default {
  name: 'PCInformacionLineaPunto',

  props: {
    modo: { type: String, default: 'volcado' }, // Modo volcado o paletizado (Por defecto volcado)
    showLineaPedidoVenta: { type: Boolean, default: false },
    showSalidaProduccion: { type: Boolean, default: false },
    salidasProduccionSeleccionadas: { type: Array, default: () => [] },
  },
  data() {
    return {
      puntoDeVolcado: null,
      lineaDeProduccion: null,
      puntoDePaletizado: null,
      lineasPedidoString: null,
      lineasPedido: false,
      salidaProduccion: false,
      salidasProduccionString: null,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'puntoDePaletizadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),
  },

  created() {
    this.puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
    this.lineaDeProduccion = this.lineaDeProduccionSeleccionada;
    this.puntoDePaletizado = this.puntoDePaletizadoSeleccionado;
    this.obtenerLineaVentaString();
    this.obtenerSalidaProduccionString();
  },

  methods: {
    obtenerLineaVentaString() {
      Log(this, this.obtenerLineaVentaString.name);
      let txtResult = '';
      if (this.puntoDeVolcado !== null) {
        if (this.puntoDeVolcado.LineasPedidoVentaAsociadas !== null && this.puntoDeVolcado.LineasPedidoVentaAsociadas !== undefined) {
          this.puntoDeVolcado.LineasPedidoVentaAsociadas.forEach((e) => {
            txtResult += `${e.PedidoVenta.Serie}/${e.PedidoVenta.Numero}-${e.Orden}, `;
            this.lineasPedido = true;
          });
        } else {
          this.lineasPedido = false;
        }
      }
      this.lineasPedidoString = txtResult.substring(0, txtResult.length - 2);
    },

    obtenerSalidaProduccionString() {
      Log(this, this.obtenerSalidaProduccionString.name);
      let txtResult = '';
      this.salidaProduccion = false;
      this.salidasProduccionSeleccionadas.forEach((e) => {
        txtResult += `${e.ElementoProduccion.Elemento.DescripcionCorta}, `;
        this.salidaProduccion = true;
      });

      this.salidasProduccionString = txtResult.substring(0, txtResult.length - 2);
    },
  },
};
</script>

<style scoped>
.div-componenteInformacionLineaYPunto {
  color: #c0c0c0d6;
  text-align: center;
  position: fixed;
  width: 100%;
  z-index: 1000;
}

.span-textoInformacionLineaYPunto {
  font-size: 18px;
  opacity: 0.7;
  color: #fff;
}

.row-componenteInformacionLineaYPunto {
  margin: 0;
}

.row-lineaPedidoVenta {
  padding-left: 4px;
  padding-right: 4px;
  max-height: max-content;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.row-salidasProduccion {
  padding-left: 4px;
  padding-right: 4px;
  max-height: max-content;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>
